/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Add_Success_SsoInputs */



/**
* | output |
* | --- |
* | "Member can now sign in with Microsoft SSO." |
*
* @param {Members_Add_Success_SsoInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_add_success_sso = /** @type {((inputs?: Members_Add_Success_SsoInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Add_Success_SsoInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mitglied kann sich jetzt mit Microsoft SSO anmelden.")
	return /** @type {LocalizedString} */ ("Member can now sign in with Microsoft SSO.")
});